import { createContext, useState, useEffect } from "react";
import secureLocalStorage from "react-secure-storage";

const MyContext = createContext();

const MyProvider = ({ children }) => {

    const BaseUrl = "https://zupper.cscodetech.com";

    const [showloginpage, setShowLoginPage] = useState(false);
    const [islogin, setIsLogin] = useState("");
    const [iscustomisable, setIsCustomisable] = useState(false);
    const [customisableitem, setCustomisableItem] = useState([]);
    const [totalcart, setTotalCart] = useState(0);
    const [locationsearch, setLocationSearch] = useState("");
    const [paymentloading, setPaymentLoading] = useState(false);
    const [paymentRes, setPaymentRes] = useState("");
    const [callHomeApi, setCallHomeApi] = useState(false);
    const [adsupdate, setAdsUpdate] = useState(0);
    const [isVegtype, setIsVagType] = useState("");
    const [isdmode, setIsDMode] = useState(false);
    const [isInstallable, setIsInstallable] = useState(false);
    const [MapKey, setMapKey] = useState("");

    useEffect(() => {
        const LocalData = secureLocalStorage.getItem("localcartdata");
        if (LocalData) {
            const { cartitem } = JSON.parse(LocalData);
            const totalcart = cartitem.reduce((sum, item) => sum + item.qty, 0);
            setTotalCart(totalcart);
        }

        const is_dmode = secureLocalStorage.getItem("is_dmode") || false;
        setIsDMode(is_dmode);
    }, []);

    const Value = {
        showloginpage, setShowLoginPage,
        islogin, setIsLogin,
        iscustomisable, setIsCustomisable,
        customisableitem, setCustomisableItem,
        totalcart, setTotalCart,
        locationsearch, setLocationSearch,
        paymentloading, setPaymentLoading,
        paymentRes, setPaymentRes,
        callHomeApi, setCallHomeApi,
        adsupdate, setAdsUpdate,
        isVegtype, setIsVagType,
        isInstallable, setIsInstallable,
        isdmode, setIsDMode,
        MapKey, setMapKey,
        BaseUrl,
    }

    return (
        <MyContext.Provider value={Value}>
            {children}
        </MyContext.Provider>
    )
}

export { MyProvider, MyContext }